import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import PublicService from "../services/PublicService";
import getProfilePictureSource from "../genericFunctions/getProfilePictureSource";
import getDisplayTranslation from "../genericFunctions/getDisplayTranslation";

const ConsultantItem = (props) => {
  const { _id, firstname, availible } = props.consultant;
  const displayTranslation = getDisplayTranslation(
    props.consultant.translations
  );
  const history = useHistory();

  const [hovered, setHovered] = useState(false);
  const [profilePic, setProfilePic] = useState("placeholder.PNG");
  const toggleHover = () => {
    setHovered(!hovered);
  };

  const visitConsultant = (id) => {
    history.push(`/consultantpage/${id}`);
  };

  useEffect(() => {
    PublicService.getPublicProfilePic(_id).then((data) => {
      if (data.profilePic) {
        setProfilePic(data.profilePic);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Paper
      elevation={3}
      style={{
        margin: "10px",
        width: "200px",
        transform: !hovered ? "" : "scale(1.01)",
        transition: "0.4s",
        cursor: "pointer",
      }}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      onClick={() => visitConsultant(_id)}
    >
      <div
        style={{
          backgroundColor: "#13222D",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          borderTopLeftRadius: "3%",
          borderTopRightRadius: "3%",
        }}
      >
        <img
          alt="Profile"
          src={getProfilePictureSource(false, profilePic)}
          style={{
            objectFit: "cover",
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            boxShadow: "0px 1px 16px -4px rgba(0,0,0,0.75)",
            border: " 2px solid #13222D",
            position: "relative",
            top: "0",
            left: "0",
          }}
        />
      </div>
      <div style={{ padding: "10px" }}>
        <h4>{firstname ? firstname : "No name..."}</h4>
        <p>{displayTranslation && displayTranslation.title}</p>

        <div style={{ display: "flex", alignItems: "center" }}>
          <p>Availability</p>
          <p
            style={{
              border: availible ? "1px solid lightgreen" : "1px solid red",
              borderRadius: "50%",
              width: "15px",
              height: "15px",
              backgroundColor: availible ? "lightgreen" : "red",
              margin: "0px 0px 15px 5px",
            }}
          ></p>
        </div>
        <p>{props.consultant.officeLocation}</p>
        <p>{props.consultant.role}</p>
      </div>
    </Paper>
  );
};

export default ConsultantItem;
